


















































import { Vue, Component, Watch } from "vue-property-decorator";
export type FeatureType = "alignment" | "font" | "color";
import { customizationStore } from "@/store/typed";
import VIcon from "@/components/Common/VIcon.vue";
import { isMobile } from "@/helpers/mediaQueryHelper";
import { EMOJI_COUNT, S3_BUCKET } from "@/constants";

type EmojiCategory = { name: string; from: number; to: number; icon: string };

@Component({ components: { VIcon } })
export default class EmojiOverlay extends Vue {
  private visible = false;
  private emojiUrl = null;
  private categories: EmojiCategory[] = [
    { name: "people", from: 0, to: 400, icon: "smile" },
    {
      name: "nature",
      from: 400,
      to: 600,
      icon: "trees",
    },
     {
      name: "food",
      from: 600,
      to: 720,
      icon: "pizza-slice",
    },
    {
      name: "activities",
      from: 720,
      to: 1200,
      icon: "trophy",
    },
    {
      name: "symbols",
      from: 1200,
      to: 1519,
      icon: "heart",
    },
    {
      name: "flags",
      from: 1519,
      to: 1799,
      icon: "sign-right",
    },
  ];

  private selectedCategory = null;

  get isMobile() {
    return isMobile((this as any).$mq);
  }

  get screenHeight(){
    return (window.innerHeight*0.75)+"px";
  }

  relativeUrl(index: number) {
    return `${S3_BUCKET}emoji_${index}.svg`;
  }

  pngRelativeUrl(index: number) {
    return `${S3_BUCKET}emoji_${index}.png`;
  }

  get categoryEmojiCount() {
    return this.selectedCategory.to - this.selectedCategory.from;
  }

  get emojisCount() {
    return EMOJI_COUNT;
  }

  show() {
    this.selectedCategory = this.categories[0];
    this.visible = true;
  }

  get isVisible() {
    return this.visible;
  }

  get clipArea() {
    return this.printArea?.clipArea;
  }

  get printArea() {
    return customizationStore?.printArea;
  }

  get printAreaWidth() {
    return this.clipArea?.width;
  }

  onEmojiSelected(url: string) {
    this.emojiUrl = url;
    this.done();
  }

  onTestEmojiSelected(url: string) {
    this.emojiUrl = url;
    this.done();
  }

  close() {
    this.visible = false;
    this.reset();
    this.$emit("done", {
      url: null,
    });
    this.$emit("close");
  }

  done() {
    this.visible = false;
    this.$emit("done", {
      url: this.emojiUrl,
    });
    this.reset();
  }

  reset() {
    this.emojiUrl = null;
  }
}
